export const schoolRoutes = [
  {
    path: "/school",
    component: () => import("@/views/School/List.vue"),
  },

  // {
  //   path: "/school/review",
  //   component: () => import("@/views/School/Review.vue"),
  // },

  {
    path: "/school/update",
    component: () => import("@/views/School/Create.vue"),
  },

  {
    path: "/school/financialdetails",
    component: () => import("@/views/School/FinancialDetails.vue"),
  },
  {
    path: "/school/dashboard/:reference",
    component: () => import("@/views/School/AdminDashboard.vue"),
  },
];
